
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/traffic/information/[state]/court/[court]",
      function () {
        return require("private-next-pages/traffic/information/[state]/court/[court]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/traffic/information/[state]/court/[court]"])
      });
    }
  